import { useState } from "react";
import { Outlet } from "react-router-dom";

import Header from "components/Header";
import SubHeader from "components/SubHeader";
import { routes } from "constants/routes";
import { LOADS_POST_HEADER_ITEMS } from "constants/sub-header";
import { useUserFeature } from "hooks/useUserFeature";
import MainLayout from "layouts/Main";
import styles from "./style.module.scss";

export default function LoadPostMain() {
  const { isShipper } = useUserFeature();
  const [viewType, setViewType] = useState("all_loads");

  return (
    <MainLayout
      desktopTitle="My Loads"
      customHeader={<Header label="My Loads" goBackPath={routes.LOADS} isHideDesktop />}
      className="pl-3.5 pr-3.5 flex-1 overflow-auto">
      <div className={styles.loadPostMainLayout}>
        {!isShipper ? (
          <SubHeader
            viewType={viewType}
            onViewTypeChange={setViewType}
            headerItems={LOADS_POST_HEADER_ITEMS}
            className="pt-3 pb-3.5"
          />
        ) : null}
        <div className={styles.body}>
          <Outlet />
        </div>
      </div>
    </MainLayout>
  );
}
